import React from "react";

/**
 * ItcotLogo — official ITCOT Limited logo.
 */
const LOGO_URL = "/itcot-logo.jpeg";

export function ItcotLogo({ className = "h-10", showWordmark = false }) {
  // showWordmark kept for backwards-compat but the image already includes the wordmark.
  return (
    <img
      src={LOGO_URL}
      alt="ITCOT Limited"
      className={`${className} w-auto object-contain select-none`}
      draggable={false}
    />
  );
}
